import { AppPurchaseMode, OperatorPurchaseMode } from './ProductTemplate.ts';

export const enum PurchaseVisibility {
    HIDDEN = 'HIDDEN',
    VISIBLE = 'VISIBLE',
}

export enum ProductAllowedCustomerPaymentMode {
    APP_PAYMENT_AND_COUNTER_AND_INDIVIDUAL_PAYMENT = 'APP_PAYMENT_AND_COUNTER_AND_INDIVIDUAL_PAYMENT',
    APP_PAYMENT_AND_COUNTER = 'APP_PAYMENT_AND_COUNTER',
    INDIVIDUAL_PAYMENT = 'INDIVIDUAL_PAYMENT',
    APP_PAYMENT = 'APP_PAYMENT',
    COUNTER = 'COUNTER',
}

export enum ProductAllowedPurchaseMode {
    APP_ONLY = 'APP_ONLY',
    OPERATOR_ONLY = 'OPERATOR_ONLY',
    APP_AND_OPERATOR = 'APP_AND_OPERATOR',
    NONE = 'NONE',
}

export function deriveGenericAllowedPurchaseMode(
    appPurchaseMode: AppPurchaseMode,
    operatorPurchaseMode: OperatorPurchaseMode,
): ProductAllowedPurchaseMode {
    if (appPurchaseMode?.appPurchaseVisibility) {
        if (operatorPurchaseMode?.operatorPurchaseVisibility) {
            return ProductAllowedPurchaseMode.APP_AND_OPERATOR;
        } else {
            return ProductAllowedPurchaseMode.APP_ONLY;
        }
    } else {
        if (operatorPurchaseMode?.operatorPurchaseVisibility) {
            return ProductAllowedPurchaseMode.OPERATOR_ONLY;
        } else {
            return ProductAllowedPurchaseMode.NONE;
        }
    }
}

export enum GuestPassDurationCalculationMode {
    CALENDAR_DAY = 'CALENDAR_DAY',
    TWENTY_FOUR_HOUR_DAY = 'TWENTY_FOUR_HOUR_DAY',
}

export function guestPassDurationCalculationModeName(
    mode: GuestPassDurationCalculationMode,
) {
    switch (mode) {
        case GuestPassDurationCalculationMode.CALENDAR_DAY:
            return {
                de: 'Kalendertag',
                fr: 'Jour calendaire',
                it: 'Giorno di calendario',
                en: 'Calendar day',
            };
        case GuestPassDurationCalculationMode.TWENTY_FOUR_HOUR_DAY:
            return {
                de: '24-Stunden-Tag',
                fr: 'Jour de 24 heures',
                it: 'Giorno di 24 ore',
                en: '24-hour day',
            };
    }
}
